import linkCopy from "../../../favicon/linkCopy.svg"
import like from "../../../favicon/reactionIcons/like.svg"
import haha from "../../../favicon/reactionIcons/haha.svg"
import love from "../../../favicon/reactionIcons/love.svg"
import sad from "../../../favicon/reactionIcons/sad.svg"
import share from "../../../favicon/reactionIcons/share.svg"
import wow from "../../../favicon/reactionIcons/wow.svg"
import angry from "../../../favicon/reactionIcons/angry.svg"
import send from "../../../favicon/reactionIcons/send.svg"
import love_black from "../../../favicon/reactionIcons/love_black.svg"
import send_black from "../../../favicon/reactionIcons/send_black.svg"
import comment from "../../../favicon/reactionIcons/comment.svg"
import { Notification, useToaster } from 'rsuite';
import currencyFormatter from "../../../Helpers/currencyFormatter"
import EmptyItem from "../../comman/EmptyItem"
import { motion } from "framer-motion";


const List = ({ ...props }) => {
    const { data, onSelectCampaignTaskRequest, filterStatus, openCampaignDetails } = props;


    const toaster = useToaster();

    const copyToClipBoard = async (copyMe, i) => {
        try {
            await navigator.clipboard.writeText(copyMe);
            toaster.push(<Notification type='success' header="Success" >

                Link has been copied in clipbord</Notification>, {
                placement: 'topEnd'
            });

        } catch (err) {

        }
    };

    const getTextColor = (status) => {
        if (status === 'Reject') {
            return 'rejectText';
        }

        if (status === 'Cancelled')
            return 'cancelText';
        if (status === 'Accept')
            return 'acceptText';
        if (status === 'Link posted')
            return 'linkText';
        if (status === 'Approved')
            return 'approveText';
        if (status === 'Pending')
            return 'pendingText';

    }

    const getStatusColor = (status) => {
        if (status === 'Reject')
            return 'reject';
        if (status === 'Cancelled')
            return 'disable';
        if (status === 'Accept')
            return 'accept';
        if (status === 'Link posted')
            return 'link';
        if (status === 'Approved')
            return 'approve';
        if (status === 'Pending')
            return 'pending';

    }

    const getTrackLinkColor = (social_platform_id) => {

        if (social_platform_id === 1)
            return 'linkBlue';
        if (social_platform_id === 2)
            return 'linkRed';
        if (social_platform_id === 3)
            return 'linkBlack';
    }

    const getStatusName = (status) => {
        if (status === 'Reject')
            return 'Rejected';
        if (status === 'Cancelled')
            return 'Cancelled';
        if (status === 'Accept')
            return 'Accepted';
        if (status === 'Link posted')
            return 'Link posted';
        if (status === 'Approved')
            return 'Approved';
        if (status === 'Pending')
            return 'Pending';
    }


    const getBgColor = (status) => {

        if (status === 'Cancelled')
            return 'disabledList';
        else {
            return 'activeList'
        }

    }
    
    const divAnimate2 = {
        offscreen: { y: 100, opacity: 0 },
        onscreen: {
            y:0,
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0,
                duration: 1
            }
        }

    };


    return (
        <>
            <div className='ms:container ms:mx-auto px-4 ms:px-2 ' >
                <>
                    {data?.length > 0 ? (
                        filterStatus === 'my_posts' ? (
                            data?.map((item, i) => (
                                <motion.div key={item?.id} variants={divAnimate2} transition={{ staggerChildren: 0.5 }} initial={"offscreen"} whileInView={"onscreen"} viewport={{ once: true, amount: 0.5 }} 
                                key={`my-posts-${item?.id}`}  >
                                    <div key={item?.id} className={`bg-white rounded-lg my-5`}
                                        style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >
                                        <h5 onClick={() => openCampaignDetails(item?.campaign)} className="text-[#178ACB] text-lg font-museobb ml-5 pt-3 cursor-pointer">{item?.campaign?.campaign_title} </h5>
                                        <div className="mx-5 " >
                                            {item?.live_post_data?.map(livePost => (
                                                <div key={`live-post-data-${livePost?.id}`} className=' flex lg:flex-row flex-col w-full  lg:my-3 ' >
                                                    <div className={` pl-2 my-2 lg:my-0 break-all flex copy-text lg:max-w-[530px] lg:min-w-[530px] sm:max-w-[auto] sm:min-w-[auto]`}>
                                                        <div className=' self-center font-museob lg:text-[15px] text-[10px] p-2 '>
                                                            {livePost?.post_link?.length > 50 ? (
                                                                `${livePost?.post_link?.slice(0, 50)} ...`
                                                            ) : (
                                                                livePost?.post_link
                                                            )}
                                                        </div>
                                                        <div className={`${getTrackLinkColor(livePost?.social_platform_id)} lg:w-[58px] w-[90px]  h-[50px] cursor-pointer flex justify-center items-center rounded-r-lg `} >
                                                            <img onClick={(e) => { e.preventDefault(); e.stopPropagation(); copyToClipBoard(livePost?.post_link, i); }}
                                                                alt='post-link' src={linkCopy} ></img>
                                                        </div>
                                                    </div>
                                                    <div className='flex my-2 lg:my-0 md:ml-8 sm:ml-0  font-museob text-center justify-between flex-wrap  ' >
                                                        {
                                                            livePost?.social_platform_id === 1 && (
                                                                <>
                                                                    <div className="sm:mr-8 md:mr-10 "> <img src={like} alt='like' ></img>  <p className='pt-1'>{livePost?.total_likes}</p> </div>
                                                                    <div className="sm:mr-8 md:mr-10 "> <img src={love} alt='love' ></img>  <p className='pt-1'>{livePost?.love}</p> </div>
                                                                    <div className="sm:mr-8 md:mr-10 "> <img src={haha} alt='haha' ></img>  <p className='pt-1'>{livePost?.haha}</p> </div>
                                                                    <div className="sm:mr-8 md:mr-10 "> <img src={wow} alt='wow'></img>     <p className='pt-1'>{livePost?.wow}</p> </div>
                                                                    <div className="sm:mr-8 md:mr-10 "> <img src={sad} alt='sad'></img>     <p className='pt-1'>{livePost?.sad}</p> </div>
                                                                    <div className="sm:mr-8 md:mr-10 "> <img src={angry} alt='angry'></img> <p className='pt-1'>{livePost?.angry}</p> </div>
                                                                    <div className="sm:mr-8 md:mr-10 "> <img src={share} alt='share'></img> <p className='pt-1'>{livePost?.total_shares}</p></div>
                                                                    <div className="sm:mr-8 md:mr-10 "> <img src={comment} alt='share'></img> <p className='pt-1'>{livePost?.total_comments}</p></div>
                                                                </>
                                                            )
                                                        }
                                                        {
                                                            livePost?.social_platform_id === 2 && (
                                                                <>
                                                                    <div className="mr-10 "> <img src={like} alt='like' ></img>  <p className='pt-1'>{livePost?.total_likes}</p> </div>
                                                                    <div className="mr-10"><img src={love} alt='love' ></img> <p className='pt-1'>{livePost?.love}</p> </div>
                                                                    <div className="mr-10"><img src={send} alt='send' ></img> <p className='pt-1'>{livePost?.total_shares}</p> </div>
                                                                </>
                                                            )
                                                        }
                                                        {
                                                            livePost?.social_platform_id === 3 && (
                                                                <>
                                                                    <div className="mr-10"><img src={love_black} alt='love_black' ></img> <p className='pt-1'>{livePost?.love}</p> </div>
                                                                    <div className="mr-10"><img src={send_black} alt='send_black' ></img> <p className='pt-1'>{livePost?.total_shares}</p> </div>
                                                                </>
                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            ))}
                                            <div className=' py-2 lg:py-3 border-t font-museob flex  items-baseline justify-end' >
                                                <p className='mr-3 ' >Total Cash Earned</p>
                                                <h3 className='font-museobb text-[#40BA47] ' >RM {currencyFormatter.format(item?.total_cash_eraned)}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            ))
                        ) : (
                            data?.map((item, i) => (
                                <motion.div key={item?.id} variants={divAnimate2} transition={{ staggerChildren: 0.5 }} initial={"offscreen"} whileInView={"onscreen"} viewport={{ once: true, amount: 0.5 }}  
                                key={`my-request-list-${item?.id}`} className={`${getBgColor(item?.status)}`} >

                                    <div key={item?.id} className="p-2  my-2 rounded-lg  "

                                        style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >
                                        <div className='flex  ' >
                                            <img className="cursor-pointer object-cover  w-[118px] h-[68px] rounded-lg " onClick={() => openCampaignDetails(item?.campaign)} src={item?.campaign?.campaignLogo} alt={item?.campaign?.id} ></img>
                                            <div className=' w-full flex ms:flex-row flex-col  justify-between md:pl-4  pl-2  ' >
                                                <div className='flex flex-col justify-between  md:max-w-[70%] ' >
                                                    <div className="cursor-pointer" onClick={() => openCampaignDetails(item?.campaign)} >
                                                        {filterStatus === "action_required" && (
                                                            <>

                                                                <h5 className="text-headingColor text-lg font-museobb  ">{item?.campaign?.campaign_title}</h5>
                                                                <p>{item?.updated_at}</p>

                                                            </>
                                                        )}
                                                        {filterStatus === "pending_client_review" && (
                                                            <>
                                                                <h5 className=" text-headingColor text-xl font-museobb ">{item?.campaign?.campaign_title}</h5>
                                                                <p className='font-museob text-base text-slate-500 '><span className='font-museobb text-slate-500'>Receive by</span> {item?.updated_at} </p>
                                                            </>
                                                        )}

                                                        {item?.status === 'Accept' && (
                                                            ', Please provide your live post '
                                                        )}

                                                        <span className={`${getTextColor(item?.status)} font-museobb`}>{getStatusName(item?.status)}</span>
                                                    </div>
                                                    {/* {filterStatus === "action_required" && (
                                                            <p className="md:pr-0 pr-2 break-all " ><span className='font-museobb'>{getStatusName(item?.status)} : </span>
                                                                {((item?.status === 'Reject') || (item?.status === 'Cancelled')) && (
                                                                    <span  >{item?.reject_reason_description}</span>
                                                                )}
                                                                {item?.status === 'Accept' && (
                                                                    ', Please provide your live post '
                                                                )}
                                                            </p>
                                                        )} */}
                                                </div>
                                                <div className='flex items-center sm:my-0 my-2 justify-center sm:justify-end sm:py-0 py-1 ' >
                                                    {filterStatus === "action_required" && (
                                                        <>
                                                            {(item?.status === 'Reject') && (
                                                                <span onClick={() => { onSelectCampaignTaskRequest(item) }} className={`items-center grid  text-white font-museo ${getStatusColor(item?.status)} text-center md:text-sm text-xs  tracking-widest rounded-full w-[130px] h-[30px] sm:w-[160px] sm:h-[33px]  lg:w-[200px] lg:h-[41px] cursor-pointer `} >COMPLETE TASK</span>
                                                            )}
                                                            {(item?.status === 'Cancelled') && (
                                                                <span className={`items-center grid  text-white font-museo ${getStatusColor(item?.status)} text-center md:text-sm text-xs tracking-widest rounded-full w-[130px] h-[30px] sm:w-[160px] sm:h-[33px]  lg:w-[200px] lg:h-[41px]`} >COMPLETE TASK</span>
                                                            )}
                                                            {item?.status === 'Accept' && (
                                                                <span onClick={() => { onSelectCampaignTaskRequest(item) }} className={`items-center grid  text-white font-museo bg-[#CF2320] text-center md:text-sm text-xs tracking-widest rounded-full w-[130px] h-[30px] sm:w-[160px] sm:h-[33px]  lg:w-[200px] lg:h-[41px]  cursor-pointer `} >COMPLETE TASK</span>
                                                            )}
                                                        </>

                                                    )}
                                                </div>

                                            </div>


                                        </div>

                                        {filterStatus === "action_required" && (
                                            <div className="md:pr-0 pr-2 break-all " >
                                                {((item?.status === 'Reject') || (item?.status === 'Cancelled')) && (
                                                    <>
                                                        <h5 className="text-[#9e1d23] text-lg font-museobb  ">{item?.reject_reason}</h5>
                                                        <span ><strong className="text-[#9e1d23]  text-xl">Reason : </strong>{item?.reject_reason_description}</span>
                                                    </>
                                                )}

                                            </div>
                                        )}

                                    </div>


                                </motion.div>

                            ))
                        )
                    ) : (
                        <EmptyItem text="No Post found" />
                    )}

                </>
            </div>

        </>

    )



}

export default List;